import React from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { FIRM } from "@/lib/firm";

// Routes that render documents / are printed into PDFs (headless Chrome) or are
// token-gated single-purpose views — the floating badge must NOT appear there,
// or it would contaminate generated binders/instruments.
const HIDDEN_PATTERNS = [
  "/print", "binder", "closing-binder", "draft-package", "draft-package",
  "/shared/", "/verify", "/redeem", "/instrument", "/resale", "loan-sign",
  "/funding/verify", "/funding/register",
];

export const CallBadge = () => {
  const { pathname } = useLocation();
  const hidden = HIDDEN_PATTERNS.some((p) => pathname.includes(p));
  if (hidden) return null;
  const telHref = `tel:${FIRM.phone.replace(/[^0-9+]/g, "")}`;
  return (
    <a
      href={telHref}
      data-testid="global-call-badge"
      title={`Call ${FIRM.name}`}
      className="print:hidden fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 rounded-full border border-[#B8860B]/40 bg-[#13130E]/90 backdrop-blur px-3.5 py-2 text-[12px] font-semibold text-[#E4C97A] shadow-lg hover:border-[#B8860B] hover:text-[#F0D98A] transition-colors"
    >
      <Phone size={13} className="text-[#B8860B]" />
      {FIRM.phone}
    </a>
  );
};

export default CallBadge;
